import React from 'react'
import Header from '../components/Header'
import Terms from '../components/Terms'
const  TermsAndCondition = () => {
  return (
    <div>
      <Header/>
      <Terms/>
    </div>
  )
}

export default TermsAndCondition